const getDefaultApiFullUrl = () => {
	const host = typeof window !== 'undefined' ? window.location.hostname : ''

	if (host === 'localhost' || host === '127.0.0.1') {
		return 'http://localhost:5000'
	}

	if (host.includes('test.broxel-eg.com')) {
		return 'https://api.broxel-eg.com'
	}

	return 'https://api.broxel-eg.com'
}

export const API_FULL_URL =
	import.meta.env.VITE_API_FULL_URL ||
	getDefaultApiFullUrl()

export const API_BASE_URL =
	import.meta.env.VITE_API_BASE_URL ||
	`${API_FULL_URL}/api`

// API Configuration
// export const API_BASE_URL = 'http://localhost:5000/api'
// export const API_BASE_URL = 'https://api.amronome.com'
// export const API_BASE_URL = 'https://test.broxel-eg.com/api'
// export const API_BASE_URL = 'https://api.broxel-eg.com/api'

// Full API URL for image paths and other absolute URLs
// export const API_FULL_URL = 'http://localhost:5000'
// export const API_FULL_URL = 'https://api.amronome.com'
// export const API_FULL_URL = 'https://test.broxel-eg.com'
// export const API_FULL_URL = 'https://api.broxel-eg.com'

// API Configuration
// Use environment variable if available, otherwise default to localhost for development
// export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api'

// Full API URL for image paths and other absolute URLs
// export const API_FULL_URL = import.meta.env.VITE_API_FULL_URL || 'http://localhost:5000'

// Production URLs (for reference):
// https://test.broxel-eg.com/api
// https://test.broxel-eg.com
